<div class="overflow-wrapper">
    <app-thesaurus-index [token]="token" (searchTermsClick)="findSearchTerm($event)" (browseTermsClick)="onBrowseTermsClick($event)" (browseCategoriesClick)="onBrowseCategoriesClick($event)" (clearTermsClick)="onClearSearchTermsClick($event)"></app-thesaurus-index>

    <div id="instructions" *ngIf="this.display">
        <div class="row">
            <h2 id="instructionsHeader" tabindex="-1">{{'initialMessage_title' | i18next}}</h2>
        </div>
        <div class="row">
            <ul>
                <li *ngFor="let key of getInitialMessageKeys(); let last = last" [hidden]="last && showNoFrillsLexicon()">
                    {{ key | i18next }}
                </li>
            </ul>
        </div>
    </div>

    <ng-container #thesaurusDetailContainer></ng-container>
    <ng-container #thesaurusSingleTermContainer></ng-container>
    <ng-container #thesaurusHierarchicalViewContainer></ng-container>
    <ng-container #thesaurusRootContainer></ng-container>

    <app-thesaurus-footer *ngIf="displayFooter" [isExplode]="isExplode()" [isMajor]="isMajor()" [displayPagination]="displayPagination" (submitThesaurusEntriesEvent)="submitThesaurusEntries($event)" (getPreviousPageEvent)="getPreviousPage()" (getNextPageEvent)="getNextPage()" [thesaurusId]="thesaurus?.id ?? ''"></app-thesaurus-footer>
</div>